import {Component, ElementRef, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FabricFlowStatsComponent} from "../../fabric-flow/fabric-flow-stats/fabric-flow-stats.component";
import {RouterLink} from "@angular/router";

@Component({
	selector: 'fb-home-artisan-flow',
	standalone: true,
	imports: [CommonModule, FabricFlowStatsComponent, RouterLink],
	templateUrl: './home-artisan-flow.component.html',
	styleUrls: ['./home-artisan-flow.component.scss']
})
export class HomeArtisanFlowComponent {

	@ViewChild('afVideo', { static: false }) video: ElementRef<HTMLVideoElement> = {} as ElementRef<HTMLVideoElement>;
	public autoPlayVideo: boolean = false;


	public playVideo($event: boolean): void {
		this.autoPlayVideo = $event;
		if(this.video) {
			if(this.autoPlayVideo) {
				this.video.nativeElement.play().then(r => {
					this.video.nativeElement.controls = true;
					this.video.nativeElement.muted = false;
				});
			}
			else {
				this.video.nativeElement.pause();
			}
		}
	}
}
